"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var CatchmentTerm = {
  ACT: 'priority enrolment area',
  VIC: 'school zone',
  TAS: 'local intake Area',
  WA: 'local intake Area',
  default: 'catchment'
};
var getCatchmentTerm = state => CatchmentTerm[state] || CatchmentTerm.default;
var _default = exports.default = getCatchmentTerm;